import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'lodash';

import log from "Utils/logger";

import CONFIG from "Config";

import * as SubscriptionActions from "Flux/subscriptions/actions";

const useFetchSubscriptions = ( ) => {
  console.log ("*** ** fetchSubscriptions : useFetchSubscriptions hook triggered ");
  const isFetchingSubscriptionsRef = useRef(false);
  const hasFetchedSubscriptionsRef = useRef(false);

  const dispatch = useDispatch();
  const storedSubscriptions = useSelector(state => state.subscriptions.availSubscriptionPlans);
  const user = useSelector(state => state.authentication.user);

  const fetchSubscriptions  = async ( ) => {
    console.log ("*** ** fetchSubscriptions : fetchSubscriptions  function triggered ");
    isFetchingSubscriptionsRef.current = true;
    try {

      let result;
      if (!user) {
        result = await dispatch(SubscriptionActions.fetchAvailableSubscriptionPlans());
      } else {
        result = await dispatch(SubscriptionActions.fetchShopperSubscriptionPlans());
      }

      console.log('*** ** fetchSubscriptions : storedSubscriptions: ', storedSubscriptions)
      console.log ('*** ** fetchSubscriptions : result: ', result);
      

      const newSubscriptions = result.data.data.map(subscription => {
        const {
          id,
          sponsor,
          product,
          name,
          amount,
          value_prop,
          charge_period,
          charge_method,
          charge_details,
          available,
          selected,
          shopper_subscribed,
          features,
        } = subscription;
      
        return {
          subscriptionID: id,
          subscriptionSponsor: sponsor,
          subscriptionProduct: product,
          subscriptionName: name,
          subscriptionAmount: amount,
          subscriptionValueProp: value_prop,
          subscriptionPeriod: charge_period,
          subscriptionChargeMethod: charge_method,
          subscriptionChargeDetails: charge_details,
          subscriptionAvailable: available,
          subscriptionOptionSelected: selected,
          shopperSubscribed: shopper_subscribed,
          subscriptionPlanFeatures: features,
        };
      });
      

      console.log('*** ** fetchSubscriptions : newSubscriptions.keys.length:',Object.keys( newSubscriptions).length)
      console.log('*** ** fetchSubscriptions : storedSubscriptions.keys.length:', Object.keys(storedSubscriptions).length)

      //console.log('*** ** fetchSubscriptions : newSubscriptions.length:',( newSubscriptions).length)
      //console.log('*** ** fetchSubscriptions : storedSubscriptions.length:', (storedSubscriptions).length)

      console.log('*** ** fetchSubscriptions : newSubscriptions: ', newSubscriptions);
      console.log('*** ** fetchSubscriptions : storedSubscriptions: ', storedSubscriptions);

      //*****MAYBE NOT NEEDED*****
      if (shouldUpdateStore(newSubscriptions, storedSubscriptions)) {

        const mergedSubscriptions = newSubscriptions.map(newSub => {
          const storedSub = storedSubscriptions.find(s => s.subscriptionID === newSub.subscriptionID);
          if (storedSub?.subscriptionOptionSelected) {
            return {
              ...newSub,
              subscriptionOptionSelected: true
            };
          }
          return newSub;
        });
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET mergedSubscriptions: ', mergedSubscriptions);
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET storedSubscriptions: ', storedSubscriptions);
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET mergedSubscriptions.length:', mergedSubscriptions.length);
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET newSubscriptions and storedSubscriptions are different');
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET newSubscriptions.length:',( newSubscriptions).length)
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET storedSubscriptions.length:', (storedSubscriptions).length)
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET newSubscriptions: ', newSubscriptions);
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET storedSubscriptions: ', storedSubscriptions);
        console.log('*** ** fetchSubscriptions : UPDATE CONDITIONS MET DISPATCH SET stores with newSubscriptions: ', newSubscriptions);
        //dispatch(SubscriptionActions.setAvailableSubscriptionPlans(newSubscriptions));
        dispatch(SubscriptionActions.setAvailableSubscriptionPlans(mergedSubscriptions));
        
      }
    } catch (exception) {
      console.log(exception);
      log({
        event: "System-Error",
        source: "FetchStores",
        info: exception,
        ...exception,
      });
    } finally {

      isFetchingSubscriptionsRef.current = false;
      hasFetchedSubscriptionsRef.current = true;
    }
  };

  // function shouldUpdateStore(newSubscriptions, storedSubscriptions) {

  //   if (!isEqual(newSubscriptions, storedSubscriptions)) {
  //     return true; // Differences found
  //   }
  //   return false; // No differences found
  // }

  function shouldUpdateStore(newSubscriptions, storedSubscriptions) {
    // If the number of plans has changed, always update.
    if (newSubscriptions.length !== storedSubscriptions.length) {
    console.log('*** ** fetchSubscriptions : shouldUpdateStore - newSubscriptions.length !== storedSubscriptions.length');
      return true;
    }
  
    // Find the selected plan from the stored subscriptions.
    //const storedSelectedPlan = storedSubscriptions.find(plan => plan.subscriptionOptionSelected);
    
    // If no plan is currently selected in the store, and the new data is different,
    // we can safely update.
    // if (!storedSelectedPlan) {
    //   console.log('*** ** fetchSubscriptions : shouldUpdateStore - no storedSelectedPlan found');
    //   return !isEqual(newSubscriptions, storedSubscriptions);
    // }
  
    // Find the corresponding new plan from the fetched data.
    //const newSelectedPlan = newSubscriptions.find(plan => plan.subscriptionID === storedSelectedPlan.subscriptionID);
  
    // If the new plan's shopperSubscribed status has changed, update.
    // if ( storedSelectedPlan.shopperSubscribed !== newSelectedPlan.shopperSubscribed) {
    //   console.log('*** ** fetchSubscriptions : shouldUpdateStore - shopperSubscribed status has changed');
    //   return true;
    // }
  
    // If a plan is selected in the store, but the new data has different content
    // for a non-selected plan, we also need to update.
    // We should compare the two arrays while ignoring the `subscriptionOptionSelected` key.
    const newSubscriptionsWithoutSelected = newSubscriptions.map(({ subscriptionOptionSelected, ...rest }) => rest);
    const storedSubscriptionsWithoutSelected = storedSubscriptions.map(({ subscriptionOptionSelected, ...rest }) => rest);
    console.log('*** ** fetchSubscriptions : shouldUpdateStore - comparing newSubscriptionsWithoutSelected and storedSubscriptionsWithoutSelected');
    console.log('*** ** fetchSubscriptions : shouldUpdateStore - newSubscriptionsWithoutSelected: ', newSubscriptionsWithoutSelected);
    console.log('*** ** fetchSubscriptions : shouldUpdateStore - storedSubscriptionsWithoutSelected: ', storedSubscriptionsWithoutSelected);
    console.log('*** ** fetchSubscriptions : shouldUpdateStore - !isEqual(newSubscriptionsWithoutSelected, storedSubscriptionsWithoutSelected): ', !isEqual(newSubscriptionsWithoutSelected, storedSubscriptionsWithoutSelected));
  
    return !isEqual(newSubscriptionsWithoutSelected, storedSubscriptionsWithoutSelected);
  }

  useEffect(() => {
    console.log('*** ** fetchSubscriptions : useEffect - triggered on load to initialise fetchSubscriptions ');
    if ( !isFetchingSubscriptionsRef.current && !hasFetchedSubscriptionsRef.current) {
      //fetchSubscriptions ( subscriptionID );
      fetchSubscriptions ( );
    }
  }, []);

  return { fetchSubscriptions  };
};

export default useFetchSubscriptions;

/*   useEffect(() => {
    if ( user
      && storedSubscriptions.length > 0
      && !isFetchingSubscriptionsRef.current
      && hasFetchedSubscriptionsRef.current
    ) {
        console.log('*** ** fetchSubscriptions : useEffect - user available: hasFetchedSubscriptionsRef.current - lets fetchFavoriteShops + fetchShopperBoostProfile')
        console.log ('*** ** fetchSubscriptions : useEffect - hasFetchedSubscriptionsRef.current - lets fetchFavoriteShops');
        fetchFavoriteShops();

    } 
    
    if (  storedSubscriptions.length > 0
        && !isFetchingSubscriptionsRef.current
        && hasFetchedSubscriptionsRef.current
      ){
       console.log ('*** ** fetchSubscriptions : useEffect - hasFetchedSubscriptionsRef.current - lets fetchStoreBoostProfiles');
       fetchStoreBoostProfiles();
    }
    
  }, [hasFetchedSubscriptionsRef.current]); */

  //return { isFetchingSubscriptionsRef.current, hasFetchedStores, fetchSubscriptions  };
//   return { fetchSubscriptions  };
// };

// export default useFetchSubscriptions;
